
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Monthlycabserviceinpimprichichwad() {



const cardData =
{
  keyword: 'Monthly Cab Service in Pimpri Chinchwad',
  heading: 'eTravo: Monthly Cab Service in Pimpri Chinchwad for Corporates and Teams',
  headingDescription: 'eTravo offers dedicated monthly cab rental services across Pimpri Chinchwad, serving the growing needs of industrial zones, IT parks, logistics hubs, and office campuses. With custom plans tailored for employee transport, executive movement, and daily business travel, we provide AC cabs driven by professional chauffeurs with GPS tracking and end-to-end fleet management. Whether it’s shift-based staff transport, VIP transfers, or inter-office connectivity, our monthly cab subscriptions guarantee comfort, punctuality, and reliability — making eTravo the go-to mobility partner for enterprises in Pimpri Chinchwad.',

  top: 'Top Business Areas in Pimpri Chinchwad Covered by Our Monthly Cab Services',
  topPlaces: [
    {
      title: 'MIDC Bhosari',
      description: 'The industrial powerhouse of Pimpri Chinchwad, home to companies like Tata Motors, Thermax, and Force Motors. eTravo’s monthly cab rentals are used for transporting factory workers, engineers, and supervisors across multiple shifts, ensuring timely arrivals with route-based planning.'
    },
    {
      title: 'Hinjewadi Phase 3 Access Point',
      description: 'Though part of the IT cluster, its proximity to PCMC means many professionals live or commute from Pimpri Chinchwad. Our cab services support daily employee pickup and drop for tech firms and consultants.'
    },
    {
      title: 'Chinchwad Gaon & Spine Road Corridor',
      description: 'This area hosts corporate parks, small industries, and service agencies. Our monthly plans here include economical cab options for sales reps, managers, and back-office staff working on field and city-wide tasks.'
    },
    {
      title: 'Talwade IT Park',
      description: 'An emerging tech hub serving SMEs and software companies. eTravo helps tech startups manage employee commutes and executive cab requirements with cost-effective monthly contracts.'
    },
    {
      title: 'Pimpri Chowk Commercial Zone',
      description: 'Surrounded by colleges, hospitals, and mid-size corporate buildings, this zone demands dependable cab services for hospital consultants, corporate trainers, and routine business visitors.'
    },
    {
      title: 'Akurdi Station Area',
      description: 'A busy transit point for office-goers, with eTravo offering last-mile connectivity to workplaces via fixed-route monthly cab plans, reducing delays and improving attendance.'
    },
    {
      title: 'Ravet & Punawale Link Belt',
      description: 'This zone is growing with IT back offices, warehouses, and educational institutions. Our cabs support daily staff transport and management-level travel with real-time updates and customizable schedules.'
    },
    {
      title: 'Nigdi Pradhikaran',
      description: 'The administrative and residential area of PCMC, serving as a hub for consultants, legal teams, and visiting officials. Our VIP monthly cab services here offer discreet, luxury travel with trained chauffeurs.'
    },
    {
      title: 'Thergaon & Kalewadi Belt',
      description: 'Packed with clinics, education centers, and small business parks, this region benefits from our compact car rentals and affordable subscription-based cab services for daily commuting staff.'
    },
    {
      title: 'Pimpri Railway Station Area',
      description: 'Acts as a junction for business and factory movement. Our monthly cab services ensure smooth pickup/drop from station to plant, office, or customer sites within PCMC limits.'
    }
  ],

  services: [
    {
      name: 'Pimpri Chinchwad Corporate Monthly Cab Rentals',
      description: 'Customized cab rental plans for companies with fixed monthly usage. We provide air-conditioned vehicles, verified drivers, and fleet coordination tailored to factory, office, and business requirements.'
    },
    {
      name: 'Long-Term Cab Service for Employees Pimpri Chinchwad',
      description: 'Our long-term employee transport model supports shifts, flexible schedules, and weekly rosters. Ideal for IT parks, MIDC zones, and large workforces who rely on punctual and safe commutes.'
    },
    {
      name: 'Monthly Business Cab Hire Pimpri Chinchwad',
      description: 'From customer visits to regional operations, our business-focused monthly rentals help your team cover more ground efficiently with reduced per-trip costs and daily availability.'
    },
    {
      name: 'Affordable Monthly Corporate Cabs Pimpri Chinchwad',
      description: 'Small and medium-sized enterprises benefit from our budget-friendly monthly plans with routes, minimal downtime, and well-maintained vehicles that ensure value without compromise.'
    },
    {
      name: 'Reliable Employee Cab Service Pimpri Chinchwad',
      description: 'We ensure 99.9% uptime for corporate clients, with standby vehicles, alternate driver coverage, and prompt escalation handling to keep your team moving without disruptions.'
    },
    {
      name: 'Executive Monthly Cab Rentals Pimpri Chinchwad',
      description: 'Luxury car rentals with chauffeurs for CEOs, VPs, and clients. Features include silent cabins, rear-seat comfort, Wi-Fi availability, and security-tracked rides.'
    },
    {
      name: 'Monthly Staff Commute Pimpri Chinchwad',
      description: 'Perfect for large factories and campuses, our staff commute model includes point-to-point routes, cluster-based cab assignments, and reporting integration with HR systems.'
    },
    {
      name: 'Corporate Lease Cab Pimpri Chinchwad',
      description: 'Long-term corporate leasing of cars for departments or managers with vehicle maintenance, driver scheduling, fuel options, and compliance management handled by eTravo.'
    },
    {
      name: 'Monthly Airport Pickup Pimpri Chinchwad',
      description: 'Airport pickups for frequent travelers and business guests. Our monthly cab plans include priority service, flight tracking, and luxury vehicle options for a seamless travel experience.'
    },
    {
      name: 'Monthly Cab for Business Trips Pimpri Chinchwad',
      description: 'Daily and intercity travel made simple with pre-booked monthly usage plans. Our business trip cabs include documentation-ready billing, flexible routes, and multi-driver scheduling.'
    },
    {
      name: 'Corporate Subscription Cab Pimpri Chinchwad',
      description: 'Subscribe to fixed cab slots daily or weekly with adjustable time windows and transparent billing. Best suited for admin teams managing daily travel for operations and meetings.'
    },
    {
      name: 'Flexible Monthly Cab Plans Pimpri Chinchwad',
      description: 'Scale up routes, change timings, or add stops mid-month with full dashboard support. We offer unmatched flexibility for companies managing remote teams and fluctuating work hours.'
    },
    {
      name: 'Long-Term Employee Cab Pimpri Chinchwad',
      description: 'Ensure dependable staff commute with dedicated cab assignments, shift-based driver rotations, and active tracking from pickup to office across PCMC industrial and tech zones.'
    },
    {
      name: 'Monthly VIP Cab Pimpri Chinchwad',
      description: 'High-end cab services for directors, partners, and visiting executives. Includes ambient interiors, climate control, bottled water, and chauffeurs trained in corporate etiquette.'
    },
    {
      name: 'Business Monthly Cab Pimpri Chinchwad',
      description: 'Suited for continuous client servicing, distribution management, and site visits. These plans support structured, reliable travel for core business functions in and around Pimpri Chinchwad.'
    }
  ],

  tableData: [
    ['Pimpri Chinchwad Corporate Monthly Cab Rentals', 'Long-Term Cab Service for Employees Pimpri Chinchwad'],
    ['Monthly Business Cab Hire Pimpri Chinchwad', 'Affordable Monthly Corporate Cabs Pimpri Chinchwad'],
    ['Reliable Employee Cab Service Pimpri Chinchwad', 'Executive Monthly Cab Rentals Pimpri Chinchwad'],
    ['Monthly Staff Commute Pimpri Chinchwad', 'Corporate Lease Cab Pimpri Chinchwad'],
    ['Monthly Airport Pickup Pimpri Chinchwad', 'Monthly Cab for Business Trips Pimpri Chinchwad'],
    ['Corporate Subscription Cab Pimpri Chinchwad', 'Flexible Monthly Cab Plans Pimpri Chinchwad'],
    ['Long-Term Employee Cab Pimpri Chinchwad', 'Monthly VIP Cab Pimpri Chinchwad'],
    ['Business Monthly Cab Pimpri Chinchwad', '']
  ],



"whychoose": [
    {
        "WhyChooseheading": "Seamless Monthly Cab Service for Pimpri Chinchwad Corporates",
        "WhyChoosedescription": "eTravo offers flexible and professional monthly cab services for companies located in Pimpri, Chinchwad, Nigdi, Akurdi, and surrounding MIDC zones—ensuring consistent and cost-effective employee transport."
    },
    {
        "WhyChooseheading": "Custom Fleet for All Business Segments",
        "WhyChoosedescription": "Choose from hatchbacks, sedans, and SUVs based on your internal teams’ needs. We serve field operations, executive mobility, and staff pickups with dedicated vehicles and reliable scheduling."
    },
    {
        "WhyChooseheading": "Dedicated Drivers and Fixed Vehicles",
        "WhyChoosedescription": "Each corporate client receives a fixed vehicle and dedicated driver for the month, ensuring familiarity, punctuality, and route efficiency in the industrial and commercial zones of PCMC."
    },
    {
        "WhyChooseheading": "No Lock-In Contracts – Flexible Monthly Plans",
        "WhyChoosedescription": "Our month-to-month model gives you full control—scale up, pause, or modify your rental depending on staffing or operational changes without any long-term obligation."
    },
    {
        "WhyChooseheading": "Fuel-Inclusive and Fuel-Free Billing Options",
        "WhyChoosedescription": "Select the pricing model that works for your business—opt for fuel-inclusive packages for convenience or fuel-free for tighter expense control."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and GPS-Enabled Cabs",
        "WhyChoosedescription": "All cabs undergo daily sanitization, regular maintenance, and come equipped with GPS, seatbelts, first-aid kits, and AC—prioritizing both safety and hygiene."
    },
    {
        "WhyChooseheading": "Live Monitoring and Admin Dashboard Access",
        "WhyChoosedescription": "Admins and HR teams can track all rides in real time, receive ETA alerts, and download detailed reports for attendance, logistics, or audit purposes."
    },
    {
        "WhyChooseheading": "GST-Compliant Invoices and Monthly Reporting",
        "WhyChoosedescription": "Enjoy corporate-ready invoices every month with GST support, digital receipts, and itemized ride logs to streamline your finance and reimbursement workflows."
    }
]
}


const faqData = [
    [
        {
            question: 'Which areas in Pimpri Chinchwad do you serve?',
            answer: 'We cover Pimpri, Chinchwad, Nigdi, Akurdi, Bhosari, MIDC areas, Hinjewadi Phase 1/2 approach roads, and other industrial zones in the PCMC region.'
        },
        {
            question: 'Can we book separate cabs for different departments?',
            answer: 'Yes, we offer multiple vehicle assignments based on department, shift, or user type with centralized reporting and dedicated drivers.'
        },
        {
            question: 'Are the drivers familiar with industrial zones and shift timings?',
            answer: 'Absolutely. Our drivers are trained, background-verified, and experienced with PCMC’s shift-based industrial transport needs.'
        },
        {
            question: 'Do vehicles come with live tracking features?',
            answer: 'Yes, all cabs are GPS-enabled. Real-time tracking and admin dashboard access allow full visibility and route control.'
        },
        {
            question: 'Is there a minimum booking requirement?',
            answer: 'No minimum duration beyond 30 days. Our monthly service can be canceled or extended as per your changing business needs.'
        },
        {
            question: 'Are GST invoices and usage reports provided?',
            answer: 'Yes, we issue digital GST-compliant invoices and detailed ride logs monthly for finance, accounting, and audit teams.'
        }
    ]
];


const testimonialsData = [
    {
        name: 'Mr. Sandeep Borkar',
        designation: 'Plant HR Manager, Apex Auto Components',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo has transformed our employee transport in PCMC. Their monthly cab service is punctual, safe, and extremely reliable.”'
    },
    {
        name: 'Ms. Manasi Kulkarni',
        designation: 'Executive Assistant, Orion Engineers Pvt. Ltd.',
        rating: [1, 1, 1, 1, 1],
        text: '“Clean cars, disciplined drivers, and timely billing—eTravo’s monthly cab rentals are perfect for our factory’s logistics needs.”'
    }
];



















    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Monthly Cab Service in Pimpri Chinchwad",
  "image": "https://www.etravo.in/images/keyword/monthly-cab-service-pimpri-chinchwad.jpg",
  "description": "Book monthly cab service in Pimpri Chinchwad for corporate employees, long-term rentals, and business travel. Affordable, reliable, and flexible corporate cab plans with professional drivers by eTravo.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "7359"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "10999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/monthly-cab-service-pimpri-chinchwad"
  }
};






    return (
        <div>

<Helmet>
  <title>Monthly Cab Service in Pimpri Chinchwad | Corporate & Executive Monthly Hire | eTravo</title>
  <meta 
    name="description" 
    content="Hire monthly corporate cabs in Pimpri Chinchwad for employees, long-term leases, and business trips. Reliable and affordable monthly cab rentals by eTravo with flexible plans." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/46.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Monthlycabserviceinpimprichichwad;